import React, { useEffect, useMemo, useState } from "react";
import { Icon, SelectField } from "@culturehq/components";
import { getQuestionsOptions } from "app/utils";
import { useProfile } from "app/context";

const StoryQuestion = ({
  story,
  fetching,
  storyQuestions = [],
  disabled,
  onSelectQuestion
}) => {
  const [question, setQuestion] = useState(undefined);
  const { profile: { organization: { createYourOwnStory } } } = useProfile();

  const options = useMemo(
    () => getQuestionsOptions({ fetching, storyQuestions }),
    [fetching, storyQuestions]
  );

  useEffect(() => setQuestion(story.question), [story]);

  const handleOnSelectQuestion = questionId => {
    const selectedQuestion = storyQuestions.find(storyQuestion => storyQuestion.id === questionId);

    setQuestion(selectedQuestion?.question || questionId);
    onSelectQuestion(selectedQuestion || questionId);
  };

  const handleCleanStoryQuestion = () => {
    setQuestion(undefined);
  };

  if (question && typeof question === "string") {
    return (
      <>
        <div className="gallery-lightbox__title-container gallery-lightbox__title-container__smaller" onClick={handleCleanStoryQuestion}>
          <Icon icon="quote" />
          <h1 className="title edit-cursor">{question}</h1>
        </div>
        <SelectField
          className="Form-Question__Prefilled"
          creatable
          name="question"
          onChange={handleOnSelectQuestion}
          options={options}
          placeholder="Add your prompt..."
          required
        >
          <Icon icon="quote" />
        </SelectField>
      </>
    );
  }

  return (
    <SelectField
      autoFocus
      className="Form-Question"
      creatable={createYourOwnStory}
      createClickNeeded={false}
      clearValueOnOpen={story.question || false}
      isDestroyable={!story.question}
      name="question"
      onChange={handleOnSelectQuestion}
      options={options}
      placeholder="Add your prompt..."
      required
      disabled={disabled}
      allWordsMatch
    >
      <Icon icon="quote" />
    </SelectField>
  );
};

export default props => (
  <div className="story-question">
    <div className="text-container">
      <div className="form">
        <div className="chq-ffd">
          <StoryQuestion {...props} />
        </div>
      </div>
    </div>
  </div>
);
